var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({class:[_vm.classes],style:({ backgroundColor: _vm.color })},'button',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"v-btn__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }